/* listStateCache.js — remembers an infinite-scroll list so going "back" from a
 * detail page returns you to where you were.
 *
 * Without this, coming back remounts the list, refetches only the first page,
 * and lands at the top — so the row you opened (say the 30th) no longer exists
 * to return to.
 *
 * Deliberately a module-level Map rather than sessionStorage: the feed can be
 * hundreds of rows with descriptions, serialising it on every navigation would
 * be wasteful, and it only needs to survive an in-app back, not a reload.
 * A full reload SHOULD start fresh.
 *
 * Entries are read only on a POP navigation (browser/router back or forward)
 * and overwritten whenever the list unmounts, so a stale one is never served
 * to a fresh visit.
 */

const cache = new Map();

export function saveListState(key, state) {
  cache.set(key, state);
}

export function readListState(key) {
  return cache.get(key);
}

export function clearListState(key) {
  cache.delete(key);
}
